export default "__VITE_ASSET__D9z1Z6RN__"